import React, { useEffect } from 'react'

import { useIntegrationActions } from 'redux/actions/Integrations'
import {
  useFortnoxStatusFetched,
  useFortnoxTenantStatus
} from 'redux/hooks/Integrations'
import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { EFortnoxTenantStatus } from 'types/Enums'
import { useTranslation } from 'language/translator'

import Alert from 'components_new/atoms/Alert'
import Button from 'components_new/atoms/Button'

/**
 * Warning shown to admins on the start page when one or more Fortnox tenants
 * are in a non-OK state (e.g. need re-authorization or lack a license).
 * Renders nothing for non-admins or when everything is healthy.
 */
const FortnoxStatusBanner = () => {
  const { t } = useTranslation()

  const { tryGetFortnoxTenantStatus } = useIntegrationActions()

  const { isAdmin } = useAccountSettings()
  const fortnoxStatus = useFortnoxTenantStatus()
  const statusFetched = useFortnoxStatusFetched()

  useEffect(() => {
    if (isAdmin && !statusFetched) {
      tryGetFortnoxTenantStatus()
    }
  }, [isAdmin, statusFetched])

  if (!isAdmin) {
    return null
  }

  const unhealthy = fortnoxStatus.filter(
    (tenant) => tenant.status !== EFortnoxTenantStatus.OK
  )

  if (unhealthy.length === 0) {
    return null
  }

  return (
    <Alert
      action={
        <Button
          color="warning"
          size="small"
          to="/settings/integrations/fortnox"
          variant="text"
        >
          {t('integrations', 'home_warning_action')}
        </Button>
      }
      severity="warning"
      sx={{ alignItems: 'center', mb: 4 }}
    >
      {t('integrations', 'home_warning', false, {
        count: unhealthy.length.toString()
      })}
    </Alert>
  )
}

export default FortnoxStatusBanner
